import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { SEOHead } from './components/feature/SEOHead';
import './i18n';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <SEOHead />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
